export interface NetworkDeepLink {
    action: string;
    payload: NetworkDeepLinkPayload;
}

interface NetworkDeepLinkPayload {
    investigationAvatar: string;
    investigationIdentifier: string;
    groupIdentifier?: string;
    groupName?: string;
    investigationTitle: string;
    email: string;
    token: string;
}

interface IDeepLink {
    action: string;
    avatar?: string;
    studyId?: string;
    groupId?: string;
    groupName?: string;
    studyTitle?: string;
    email?: string;
    token?: string;
}


export class DeepLink {

  action: string;
  avatar?: string;
  studyId?: string;
  groupId?: string;
  studyTitle?: string;
  groupName?: string;
  email?: string;
  token?: string;

  constructor(link: IDeepLink) {
    this.action = link.action;
    this.avatar = link.avatar;
    this.studyId = link.studyId;
    this.groupId = link.groupId;
    this.groupName = link.groupName;
    this.studyTitle = link.studyTitle;
    this.email = link.email;
    this.token = link.token;
  }

  static mapLink(link: NetworkDeepLink) {
    const payload = link.payload;
    return new DeepLink({
      action: link.action,
      avatar: payload.investigationAvatar,
      studyId: payload.investigationIdentifier,
      groupId: payload.groupIdentifier,
      groupName: payload.groupName,
      studyTitle: payload.investigationTitle,
      email: payload.email,
      token: payload.token
    });
  }
}
